import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { useOverlay } from '../../hooks/useOverlay';
import { easeOut } from '../../utils/motion';
import type { ShopFiltersState } from '../../hooks/useShopFilters';
import { btnPrimary } from '../ui/buttonStyles';
import { ShopFilters } from './ShopFilters';
interface FilterDrawerProps {
  open: boolean;
  onClose: () => void;
  filters: ShopFiltersState;
}
export function FilterDrawer({
  open,
  onClose,
  filters
}: FilterDrawerProps) {
  useOverlay(open, onClose);
  return <AnimatePresence data-id="element-571" data-mp="1q9kcggx6n6yd">
      {open && <>
          <motion.div className="fixed inset-0 z-50 bg-ink/40 lg:hidden" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} onClick={onClose} aria-hidden data-id="element-572" data-mp="1q90y1a6qr0p3" />
          <motion.div role="dialog" aria-modal="true" aria-label="Filtres" className="fixed inset-x-0 bottom-0 z-50 flex max-h-[85vh] flex-col rounded-t-2xl bg-paper lg:hidden" initial={{
        y: '100%'
      }} animate={{
        y: 0
      }} exit={{
        y: '100%'
      }} transition={{
        duration: 0.3,
        ease: easeOut
      }} data-id="element-573" data-mp="1ucqjvrw1746f">
            <div className="flex items-center justify-between border-b border-line px-5 py-4" data-id="element-574" data-mp="ouf1x35t4eqj">
              <h2 className="font-display text-2xl" data-id="element-575" data-mp="stwai5gj5rzx">Filtrer</h2>
              <button type="button" onClick={onClose} aria-label="Fermer les filtres" className="flex h-10 w-10 items-center justify-center rounded-full hover:bg-shell" data-id="element-576" data-mp="xt0fsl0c35kz">
                <XIcon className="h-5 w-5" data-id="element-577" data-mp="12mlaa32pxhff" />
              </button>
            </div>
            <div className="flex-1 overflow-y-auto px-5 py-5" data-id="element-578" data-mp="17lel1nqmeubw">
              <ShopFilters filters={filters} data-id="element-579" data-mp="1cjg7min99bs4" />
            </div>
            <div className="border-t border-line p-4" data-id="element-580" data-mp="1gjqlehhah6hj">
              <button type="button" onClick={onClose} className={`${btnPrimary} w-full`} data-id="element-581" data-mp="1gk9sf35eiags">
                Voir {filters.results.length} pièce{filters.results.length > 1 ? 's' : ''}
              </button>
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}